import React from 'react';
import { useBaseUrls } from 'hooks';

export default Component => props => (
    <Component {...props} baseUrls={useBaseUrls()} />
);
